var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container",
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search.apply(null, arguments);
      }
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": _vm.placeholder,
      "autofocus": ""
    },
    model: {
      value: _vm.input.value,
      callback: function ($$v) {
        _vm.$set(_vm.input, "value", $$v);
      },
      expression: "input.value"
    }
  }), _c('el-button', {
    staticClass: "button",
    attrs: {
      "icon": "el-icon-search",
      "type": "primary",
      "round": "",
      "loading": _vm.loading.searchBox
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(" Search ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }